<template>
  <div :style="{height: height}"></div>
</template>

<script>
export default {
  name: "MyDivider",
  props: ["height"],
}
</script>

<style scoped>
.divider {
  height: 30px;
}
</style>
